// Visible error banner — used wherever a mutation/form-submit can fail
// with a user-facing message. Replaces the silent
// `<p className="text-danger text-sm">{err}</p>` pattern that made the
// "Привязать" button look like it was doing nothing on a 409.

import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function ErrorBanner({
  children,
  onDismiss,
}: {
  children: ReactNode;
  onDismiss?: () => void;
}) {
  const { t } = useTranslation();
  if (!children) return null;
  return (
    <div
      role="alert"
      data-testid="error-banner"
      className="border border-danger bg-danger/10 text-danger px-3 py-2 rounded-md text-sm flex items-start gap-2"
    >
      <span className="font-mono text-xs mt-0.5">!</span>
      <span className="flex-1">{children}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="text-danger/70 hover:text-danger font-mono text-xs"
          aria-label={t("common.close")}
        >
          ×
        </button>
      )}
    </div>
  );
}
